export enum LeaveStatus {
  Approved = 0,
  Declined = 1,
  Pending = 2,
  Draft = 3,
}

export enum EmployeeStatus {
  Active = 1,
  Inactive = 0,
}
export enum CandidateStatus {
  Saved = 'Saved',
  Shortlisted = 'Shortlisted',
  InterviewScheduled = 'InterviewScheduled',
  Selected = 'Selected',
  InterviewCancelled = 'InterviewCancelled',
  Intern = 'Intern',
  Employee = 'Employee',
  Rejected = 'Rejected',
  InProgress = 'InProgress',
}
export enum RoleStatus {
  Active = 1,
  Inactive = 0,
}
export enum LeaveManagementStatus {
  Active = 1,
  Inactive = 0,
}
export enum ClientStatus {
  Active = 1,
  Inactive = 0,
}
export enum ClientProjectStatus {
  Draft = 'Draft',
  InProgress = 'InProgress',
  Hold = 'Hold',
  Delivered = 'Delivered',
}
export enum AssetStatus {
  Assigned = 0,
  Available = 1,
  Damaged = 2,
  Default = 3,
  Repairing = 4,
  Repaired = 5,
}
export enum RepairingStatus {
  Repairing = 0,
  Repaired = 1,
  Assigned = 2,
}

export enum ProjectStatus {
  Draft = 'Draft',
  InProgress = 'InProgress',
  Hold = 'Hold',
  Delivered = 'Delivered',
}
export enum PriorityStatus {
  Low = 0,
  High = 1,
  Medium = 2,
}
export enum IntervieweeStatus {
  Selected = 'Selected',
  InterviewCancelled = 'InterviewCancelled',
  Rejected = 'Rejected',
  InProgress = 'InProgress',
  InterviewScheduled = 'InterviewScheduled',
  DecisionPending = 'DecisionPending',
}
export enum ReviewStatus {
  Good = 'Good',
  Poor = 'Poor',
  Average = 'Average',
  VeryGood = 'VeryGood',
  Excellent = 'Excellent',
}
export enum InternStatus {
  PromotedAsEmployee = 'PromotedAsEmployee',
  Candidate = 'Candidate',
  SelectedAsEmployee = 'SelectedAsEmployee',
  SelectedAsIntern = 'SelectedAsIntern',
  InternFinalWeek = 'InternFinalWeek',
}

export enum ETAStatus {
  InProgress = 'In-Progress',
  completed = 'Completed',
}

export enum RoleId {
  superAdmin = 1,
  manager = 2,
  intern = 3,
  candidate = 4,
  employee = 5,
}
